// TODO once all pages that checklist cover are in SPA, we should change this to use matchedRoute instead of pathname

import findKey from 'lodash/findKey';
import { isClientFetchError } from '@atlassian/jira-fetch/src/utils/is-error.tsx';

export const isInQueuesPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);

export const isInIssuesPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) ||
	/\/browse\/[\w\W]+$/.test(pathname);

export const isInReportsPage = (pathname: string) => /\/projects\/[\w\d]+\/reports/.test(pathname);

export const isInKnowledgeBasePage = (pathname: string) =>
	/\/projects\/[\w\d]+\/knowledge/.test(pathname);

export const isInCustomersPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/customers$/.test(pathname);

export const isInOrganizationsPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);

export const isInEditReportsPage = (pathname: string) =>
	isInReportsPage(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));

export const isInEditQueuesPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) ||
	/\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);

export const isInServicesPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);

export const isInOnCallPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);

export const isInIncidentsPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);

export const isInProblemsPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);

export const isInChangesPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);

export const isInServiceRequestsPage = (pathname: string) =>
	/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);

export const isInClassicSettingsDetailsPage = (pathname: string) =>
	/\/secure\/project\/EditProject!default.jspa/.test(pathname);

export const isInClassicSettingsPeoplePage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);

export const isInClassicSettingsSummaryPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);

export const isInClassicSettingsIssueTypesPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);

export const isInClassicSettingsRequestTypesPage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);

export const isInClassicSettingsChangeManagementPage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);

export const isInClassicSettingsCustomerPermissionsPage = (pathname: string) =>
	/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);

export const isInClassicSettingsLanguagePage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);

export const isInClassicSettingsPortalPage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);

export const isInClassicSettingsEmailPage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);

export const isInClassicSettingsEmailAliasPage = (pathname: string) =>
	/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);

export const isInClassicSettingsCustomerNotificationsPage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);

export const isInClassicSettingsWidgetPage = (pathname: string) =>
	/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);

export const isInClassicSettingsFeedbackPage = (pathname: string) =>
	/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);

export const isInClassicSettingsConfluencePage = (pathname: string) =>
	/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);

export const isInClassicSettingsSlaPage = (pathname: string) =>
	/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);

export const isInClassicSettingsAutomationPage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);

export const isInClassicSettingsAppsPage = (pathname: string) =>
	/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);

export const isInClassicSettingsWorkflowsPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);

export const isInClassicSettingsScreensPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);

export const isInClassicSettingsFieldsPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);

export const isInClassicSettingsVersionsPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);

export const isInClassicSettingsComponentsPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);

export const isInClassicSettingsPermissionsPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);

export const isInClassicSettingsIssueSecurityPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);

export const isInClassicSettingsNotificationsPage = (pathname: string) =>
	/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);

export const isInClassicSettingsIssueCollectorsPage = (pathname: string) =>
	/\/secure\/ViewCollectors!default.jspa/.test(pathname);

export const isInClassicSettingsPage = (pathname: string) =>
	isInClassicSettingsDetailsPage(pathname) ||
	isInClassicSettingsPeoplePage(pathname) ||
	isInClassicSettingsSummaryPage(pathname) ||
	isInClassicSettingsIssueTypesPage(pathname) ||
	isInClassicSettingsRequestTypesPage(pathname) ||
	isInClassicSettingsChangeManagementPage(pathname) ||
	isInClassicSettingsCustomerPermissionsPage(pathname) ||
	isInClassicSettingsLanguagePage(pathname) ||
	isInClassicSettingsPortalPage(pathname) ||
	isInClassicSettingsEmailPage(pathname) ||
	isInClassicSettingsEmailAliasPage(pathname) ||
	isInClassicSettingsCustomerNotificationsPage(pathname) ||
	isInClassicSettingsWidgetPage(pathname) ||
	isInClassicSettingsFeedbackPage(pathname) ||
	isInClassicSettingsConfluencePage(pathname) ||
	isInClassicSettingsSlaPage(pathname) ||
	isInClassicSettingsAutomationPage(pathname) ||
	isInClassicSettingsAppsPage(pathname) ||
	isInClassicSettingsWorkflowsPage(pathname) ||
	isInClassicSettingsScreensPage(pathname) ||
	isInClassicSettingsFieldsPage(pathname) ||
	isInClassicSettingsVersionsPage(pathname) ||
	isInClassicSettingsComponentsPage(pathname) ||
	isInClassicSettingsPermissionsPage(pathname) ||
	isInClassicSettingsIssueSecurityPage(pathname) ||
	isInClassicSettingsNotificationsPage(pathname) ||
	isInClassicSettingsIssueCollectorsPage(pathname);

const screenNameMap = {
	queues: isInQueuesPage,
	issues: isInIssuesPage,
	customers: isInCustomersPage,
	reports: isInReportsPage,
	knowledge: isInKnowledgeBasePage,
	services: isInServicesPage,
	onCall: isInOnCallPage,
	incidents: isInIncidentsPage,
	problems: isInProblemsPage,
	changes: isInChangesPage,
	serviceRequests: isInServiceRequestsPage,
	classicSettingsDetails: isInClassicSettingsDetailsPage,
	classicSettingsPeople: isInClassicSettingsPeoplePage,
	classicSettingsSummary: isInClassicSettingsSummaryPage,
	classicSettingsIssueTypes: isInClassicSettingsIssueTypesPage,
	classicSettingsRequestTypes: isInClassicSettingsRequestTypesPage,
	classicSettingsChangeManagement: isInClassicSettingsChangeManagementPage,
	classicSettingsCustomerPermissions: isInClassicSettingsCustomerPermissionsPage,
	classicSettingsLanguage: isInClassicSettingsLanguagePage,
	classicSettingsPortal: isInClassicSettingsPortalPage,
	classicSettingsEmail: isInClassicSettingsEmailPage,
	classicSettingsEmailAlias: isInClassicSettingsEmailAliasPage,
	classicSettingsCustomerNotifications: isInClassicSettingsCustomerNotificationsPage,
	classicSettingsWidget: isInClassicSettingsWidgetPage,
	classicSettingsFeedback: isInClassicSettingsFeedbackPage,
	classicSettingsConfluence: isInClassicSettingsConfluencePage,
	classicSettingsSla: isInClassicSettingsSlaPage,
	classicSettingsAutomation: isInClassicSettingsAutomationPage,
	classicSettingsApps: isInClassicSettingsAppsPage,
	classicSettingsWorkflows: isInClassicSettingsWorkflowsPage,
	classicSettingsScreens: isInClassicSettingsScreensPage,
	classicSettingsFields: isInClassicSettingsFieldsPage,
	classicSettingsVersions: isInClassicSettingsVersionsPage,
	classicSettingsComponents: isInClassicSettingsComponentsPage,
	classicSettingsPermissions: isInClassicSettingsPermissionsPage,
	classicSettingsIssueSecurity: isInClassicSettingsIssueSecurityPage,
	classicSettingsNotifications: isInClassicSettingsNotificationsPage,
	classicSettingsIssueCollectors: isInClassicSettingsIssueCollectorsPage,
} as const;

export const getCurrentPageName = (pathname: string) =>
	findKey(screenNameMap, (isCurrentScreen) => isCurrentScreen(pathname)) || '';

export const isExpectedError = (
	error: Error,
): boolean => // users and pollinator checks can cause client side failed to fetch errors,
	// these are out of our control so treat them as expected
	isClientFetchError(error);

const GSP_EXCLUDED_PAGES_FILTER = {
	pathnameRegexes: [
		// 'Classic Settings Customer Notifications',
		'/servicedesk/admin/[\\w\\d]+/customer-notifications',
	],
	pathnameRegexesForNple: [
		// 'Classic Settings Customer Notifications',
		'/servicedesk/admin/[\\w\\d]+/customer-notifications',
		// 'Portal Settings Page'
		'/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
		// 'People Page'
		'/plugins/servlet/project-config/[\\w\\d]+/people',
		// 'Getting Started Page'
		'/jira/servicedesk/projects/[\\w\\d]+/getting-started',
	],
	routeNames: [
		// 'Reports',
		'servicedesk-reports',
		// 'Reports - Custom',
		'servicedesk-reports-custom',
		// 'Reports - Create',
		'servicedesk-reports-custom-create',
		// 'Reports - Edit',
		'servicedesk-reports-custom-edit',
		// 'Reports - Time Scale Issue',
		'servicedesk-reports-custom-time-scale-issue',
		// 'Reports - Time Scale',
		'servicedesk-reports-custom-time-scale',
		// 'Reports - Satisfaction',
		'servicedesk-reports-satisfaction',
		// 'Reports - Satisfaction Time Scale Issue',
		'servicedesk-reports-satisfaction-time-scale-issue',
		// 'Reports - Satisfaction TIme Scale',
		'servicedesk-reports-satisfaction-time-scale',
		// 'Reports - Type',
		'servicedesk-reports-type',
		// 'Reports - Workload',
		'servicedesk-reports-workload',
		// 'Queues - New',
		'servicedesk-queues-new',
		// 'Queues - Edit',
		'servicedesk-queues-edit',
	],
};

const GSP_INCLUDED_PAGES_FILTER = {
	pathnameRegexes: ['/jira/people/search'],
};

export const shouldIncludePathname = (pathname: string): boolean =>
	GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex) => new RegExp(regex).test(pathname));

export const shouldExcludePathname = (pathname: string, isNpleForItsmEnabled: boolean): boolean =>
	isNpleForItsmEnabled
		? GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex) =>
				new RegExp(regex).test(pathname),
			)
		: GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex) => new RegExp(regex).test(pathname));

export const shouldExcludeRouteName = (currentRouteName: string): boolean =>
	GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName) => routeName === currentRouteName);
